<ng-container *ngIf="navigationInProgress">
  <div class="loaderContainer">
    <div
      class="overlay-loader d-flex justify-content-center align-items-center flex-column">
      <h1>Loading</h1>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  </div>
</ng-container>
